import { ITextFieldProps, TextField } from '@amagimedia/amagi-design-system';
import { useField } from 'formik';
import { ChangeEventHandler, FunctionComponent } from 'react';

interface IProps extends ITextFieldProps {
  name: string;
  integer?: boolean;
  min?: number;
  max?: number;
}

export const FormikNumberField: FunctionComponent<IProps> = (props) => {
  const [field, meta, helpers] = useField(props.name);
  //de-structuring so that we don't pass integer prop to TextField
  //this is to avoid the warning, Warning: Received `true` for a non-boolean attribute. integer
  const { integer, ...rest } = props;

  const errorMessage = meta.touched ? meta.error : '';

  const handleChange: ChangeEventHandler<HTMLInputElement> = (e) => {
    let value = e.target.value.trim();
    if (integer) {
      value = value.replace('.', '');
    }
    let num = Number(value);
    if (isNaN(num)) {
      return;
    }
    if (props.min && num < props.min) {
      num = props.min;
    }
    if (props.max && num > props.max) {
      num = props.max;
    }
    helpers.setValue(num);
  };

  return (
    <TextField
      id={field.name}
      value={field.value}
      onChange={handleChange}
      onBlur={field.onBlur}
      errorMessage={errorMessage}
      {...rest}
    />
  );
};
